import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { SecondaryButtonProps } from "@/views/blocks/cta/shared/secondary-button/SecondaryButtonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'SecondaryButton',
  props: {
    href: {},
    label: {},
    textColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "7e52b694": (_ctx.textColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "text-sm xl:text-base",
    style: _normalizeStyle({ color: _ctx.textColor })
  }, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
  ], 12, _hoisted_1))
}
}

})